const proofs = [
  {
    src: 'https://4kkdream.com/4.webp',
    label: 'Client UK – Paid via Credit Card',
  },
  {
    src: 'https://4kkdream.com/5.webp',
    label: 'Client France – Paid via PayPal',
  },
  {
    src: 'https://4kkdream.com/6.webp',
    label: 'Client Canada – Paid via Credit Card',
  },
];

const stats = [
  { value: 'Thousands', label: 'Satisfied Clients' },
  { value: '4.9/5', label: 'Average Rating' },
  { value: '7 Years', label: 'In Business' },
];

const SocialProof = () => (
  <section className="py-12 sm:py-16 md:py-20 bg-gray-950 relative overflow-hidden">
    <div className="absolute inset-0 opacity-5 pointer-events-none">
      <div className="absolute top-1/3 left-1/4 w-80 h-80 bg-emerald-500 rounded-full blur-[120px]"></div>
      <div className="absolute bottom-1/3 right-1/4 w-80 h-80 bg-cyan-500 rounded-full blur-[120px]"></div>
    </div>

    <div className="max-w-7xl mx-auto px-4 sm:px-6 relative z-10">
      <div className="text-center mb-10 sm:mb-14">
        <div className="inline-flex items-center gap-2 bg-emerald-500/10 border border-emerald-500/20 rounded-full px-4 py-2 mb-4 sm:mb-6">
          <span className="text-sm font-medium text-emerald-400">Payment Proofs</span>
        </div>
        <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-black text-white mb-3 sm:mb-4 tracking-tight">
          Thousands of Satisfied <span className="text-emerald-400">Clients</span>
        </h2>
        <p className="text-gray-400 text-base sm:text-lg max-w-2xl mx-auto">
          Real proofs from our clients — verified payments and subscriptions activated live
        </p>
      </div>

      <div className="max-w-5xl mx-auto relative">
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
          {proofs.map((p) => (
            <div
              key={p.label}
              className="group relative rounded-2xl overflow-hidden border border-white/10 hover:border-emerald-500/40 transition-all duration-300 bg-gray-900/60"
            >
              <div className="aspect-[9/16] overflow-hidden">
                <img
                  alt={p.label}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                  src={p.src}
                />
              </div>
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/90 via-black/50 to-transparent p-4">
                <span className="text-xs sm:text-sm text-white font-medium truncate block">{p.label}</span>
                <div className="flex gap-0.5 mt-1.5">
                  {[...Array(5)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-amber-400 text-xs"></i>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="mt-12 sm:mt-16 flex flex-wrap justify-center gap-8 sm:gap-12">
        {stats.map((s) => (
          <div key={s.label} className="text-center">
            <div className="text-3xl sm:text-4xl font-black text-emerald-400">{s.value}</div>
            <div className="text-sm text-gray-500">{s.label}</div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default SocialProof;
